import { MousePointerClick } from "lucide-react";
import { ClickStatsChart } from "@/components/ClickStatsChart";

export const ClickLeaderboard = ({ rows, daily, totalClicks }) => (
  <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-testid="click-stats-section">
    <div className="bg-card border border-border rounded-xl p-5">
      <h3 className="font-semibold flex items-center gap-2"><MousePointerClick className="h-4 w-4 text-cyan-400" /> Klik Link Afiliasi</h3>
      <p className="font-display text-3xl font-bold mt-3 font-mono" data-testid="admin-total-clicks">{totalClicks}</p>
      <p className="text-xs text-muted-foreground mb-3">Total klik semua talent • 14 hari terakhir:</p>
      <ClickStatsChart data={daily} height={180} />
    </div>
    <div className="lg:col-span-2 bg-card border border-border rounded-xl p-5 overflow-x-auto">
      <h3 className="font-semibold mb-4">Klik & Konversi per Talent</h3>
      <table className="w-full text-sm" data-testid="click-leaderboard-table">
        <thead>
          <tr className="text-left text-xs text-muted-foreground border-b border-border">
            <th className="pb-2 font-medium">Talent</th>
            <th className="pb-2 font-medium text-right">Link Produk</th>
            <th className="pb-2 font-medium text-right">Klik</th>
            <th className="pb-2 font-medium text-right">Order</th>
            <th className="pb-2 font-medium text-right">Konversi</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={i} className="border-b border-border/50" data-testid={`click-row-${i}`}>
              <td className="py-2.5">
                <p className="font-medium">{r.name}</p>
                {r.tiktok_handle && <p className="text-[11px] font-mono text-cyan-400">{r.tiktok_handle}</p>}
              </td>
              <td className="py-2.5 text-right font-mono">{r.links}</td>
              <td className="py-2.5 text-right font-mono text-amber-400">{r.clicks}</td>
              <td className="py-2.5 text-right font-mono">{r.orders}</td>
              <td className="py-2.5 text-right font-mono text-emerald-400">{r.clicks ? `${r.conversion_pct}%` : "-"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);
